module.exports = __webpack_public_path__ + "img/contact-seen.24d95769.svg";